<template>
  <div class="physiquePage">
    <div class="physique">
      <div class="physique-img">
        <left style="color: #ffffff"></left>
      </div>
    </div>
    <div class="chart_box">
      <div class="chart_top">
        <div class="chart_top_l">体格数据记录曲线</div>
        <div class="chart_top_r" @click="show = true">
          {{ start_date }} 至 {{ end_date }}
        </div>
      </div>
      <Echart :options="option" id="huanChart" height="233px" width="100%" />
      <div class="chart_bottom">
        <div :class="isChose == 1 ? 'chose_btn' : 'btn'" @click="goChose(1)">
          体重
        </div>
        <div :class="isChose == 2 ? 'chose_btn' : 'btn'" @click="goChose(2)">
          身高
        </div>
        <div :class="isChose == 3 ? 'chose_btn' : 'btn'" @click="goChose(3)">
          腰围
        </div>
        <div :class="isChose == 4 ? 'chose_btn' : 'btn'" @click="goChose(4)">
          臀围
        </div>
        <div :class="isChose == 5 ? 'chose_btn' : 'btn'" @click="goChose(5)">
          BMI
        </div>
      </div>
    </div>
    <!--    ========-->
    <div class="info-box">
      <div class="info-title">
        <img src="../assets/imgs/title_img@2x.png" alt="" />
        <div class="info-title-txt">数据记录</div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="info-box-items"
          style="display: flex"
          v-for="(item, index) in itemList[0]"
          :key="index"
        >
          <div class="items-dian"></div>
          <div class="item-w" style="display: flex; flex-direction: column">
            <div class="item-date">{{ item.date }}</div>
            <div class="item-box">
              <div style="display: flex; justify-content: space-between">
                <div class="BMI-font">
                  BMI={{ item.bmi ? item.bmi : "0" }}kg/㎡
                  <span
                    v-if="item.standard_bmi && item.standard_bmi != '正常'"
                    :style="
                      item.standard_bmi.indexOf('肥胖') > -1 ||
                      item.standard_bmi.indexOf('超重') > -1
                        ? 'color: red'
                        : item.standard_bmi.indexOf('消瘦') > -1
                        ? 'color:red'
                        : ''
                    "
                    >({{ item.standard_bmi }})</span
                  >
                </div>
                <div style="display: flex; align-items: center">
                  <img src="../assets/imgs/体格-icon@2x.png" />
                  <div
                    class="BMI-icon"
                    @click="
                      goEdit(
                        index,
                        item.bmi,
                        item.height,
                        item.weight,
                        item.hipline,
                        item.waistline
                      )
                    "
                  >
                    修改
                  </div>
                </div>
              </div>
              <div class="item-box-bottom">
                <div class="font">
                  身高:{{ item.height }}cm<span
                    v-if="
                      item.standard_height && item.standard_height != '正常'
                    "
                    :style="
                      item.standard_height.indexOf('迟缓') > -1
                        ? 'color:red'
                        : ''
                    "
                    >({{ item.standard_height }})</span
                  >
                  <br />
                  <br />
                  体重:{{ item.weight }}kg
                </div>
                <div class="font2 font">
                  腰围:{{ item.waistline }}cm
                  <br />
                  <br />
                  臀围:{{ item.hipline }}cm
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!--        <div class="info-btn" @click="goEdit1(itemList[0].index,itemList[0].bmi,itemList[0].height,itemList[0].weight,itemList[0].hipline,itemList[0].waistline)">-->
    <!--            记录今天的体格-->
    <!--        </div>-->
    <van-calendar
      v-model="show"
      type="range"
      @confirm="onConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      :max-range="30"
      :default-date="choseDate"
    />
    <div class="info-btn" @click="goEdit1(itemList[0])">记录今天的体格</div>
  </div>
</template>

<script>
import { recordList,tgqx } from "../service/api";
import left from "../components/arrow-left";
import Echart from "@/common/echart";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "physique",
  data() {
    return {
      loading: false,
      // finished:true,
      finished: false,
      d: "",
      m: "",
      y: "",
      itemList: [],
      itemObj: {},
      //获取当月 （常量）
      mm: "",

      date: "",
      show: false,
      option: {}, // 折线图
      isChose: 1, // 图表选中
      danwei: "",
      dataY: [], // Y轴数据
      dataX: [], //X轴数据
      start_date: "", //开始时间
      end_date: "", //结束时间
      choseDate: [],
      minDate: new Date(1900, 1, 1, 0, 0, 0),
    };
  },
  components: {
    left,
    Echart,
  },
  created() {
    // 1，进来先获取当前年月日，存入本地
    this.d = this.dayjs().format("DD");
    this.m = this.dayjs().format("M");
    this.mm = this.dayjs().format("M");
    this.y = this.dayjs().format("YYYY");

    // 前七天
    this.start_date = this.getBeforeDate(7);
    // 当天
    this.end_date = this.y + "-" + this.m + "-" + this.d;
    this.choseDate[0] = new Date(this.start_date);
    this.choseDate[1] = new Date(this.end_date);
    this.goChose(1);
  },
  methods: {
    //时间格式化
    getBeforeDate(time) {
      var n = time;
      var d = new Date();
      var year = d.getFullYear();
      var mon = d.getMonth() + 1;
      var day = d.getDate();
      if (day <= n) {
        if (mon > 1) {
          mon = mon - 1;
        } else {
          year = year - 1;
          mon = 12;
        }
      }
      d.setDate(d.getDate() - n);
      year = d.getFullYear();
      mon = d.getMonth() + 1;
      day = d.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    // 日期格式
    formatDate(date) {
      let year = date.getFullYear();
      let mon = date.getMonth() + 1;
      let day = date.getDate();
      let s =
        year +
        "-" +
        (mon < 10 ? "0" + mon : mon) +
        "-" +
        (day < 10 ? "0" + day : day);
      return s;
    },
    // 日期选择
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.start_date = this.formatDate(start);
      this.end_date = this.formatDate(end);
      this.goChose(this.isChose);
    },
    // 折线图选中
    goChose(val) {
      this.isChose = val;
      // 1体重，2身高，3腰围，4臀围，5BMI
      switch (val) {
        case 1:
          this.goChoseName = "体重";
          break;
        case 2:
          this.goChoseName = "身高";
          break;
        case 3:
          this.goChoseName = "腰围";
          break;
        case 4:
          this.goChoseName = "臀围";
          break;
        case 5:
          this.goChoseName = "BMI";
          break;
      }
      let params = {
         // 1体重，2身高，3腰围，4臀围，5BMI
        key: val,
        start_date: this.start_date,
        end_date: this.end_date,
      };
      tgqx(params)
        .then((res) => {
          console.log("折线图选中", res);
          this.dataX = res.data.x;
          this.dataY = res.data.y;
          this.danwei = res.data.unit;
          this.changeChart();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onLoad() {
      recordList({ date: this.timer() })
        .then((res) => {
          console.log(res);
          // 如果是当月，则用this.d 作为做大天数
          if (this.m === this.mm) {
            console.log("是当月");
            let i;
            let ddd;
            for (i = parseInt(this.d); i > 0; i--) {
              if (i < 10) {
                i = "0" + i;
              }
              if (this.m < 10) {
                ddd = this.y + "-" + "0" + this.m + "-" + i;
              } else {
                ddd = this.y + "-" + this.m + "-" + i;
              }
              this.itemObj[ddd] = {
                date: ddd,
                id: 0, //用户ID
                weight: "0",
                height: "0",
                waistline: "0",
                hipline: "0",
                bmi: "",
              };
            }
            this.itemObj = { ...this.itemObj, ...res.data.list };
            // console.log(res.data.list)
            // console.log(typeof res.data.list)
            this.itemList = [this.itemObj];
            this.m -= 1;
            if (this.m === 0) {
              this.y -= 1;
              this.m = 12;
            }
            this.loading = false;
          } else {
            console.log("不是当月");
            let i;
            let ddd;
            for (i = this.getMouthDay(this.y, this.m); i > 0; i--) {
              if (i < 10) {
                i = "0" + i;
              }
              if (this.m < 10) {
                ddd = this.y + "-" + "0" + this.m + "-" + i;
              } else {
                ddd = this.y + "-" + this.m + "-" + i;
              }
              this.itemObj[ddd] = {
                date: ddd,
                id: 0, //用户ID
                weight: "0",
                height: "0",
                waistline: "0",
                hipline: "0",
                bmi: "",
              };
            }
            this.itemObj = { ...this.itemObj, ...res.data.list };
            this.itemList = [this.itemObj];
            this.m -= 1;
            if (this.m === 0) {
              this.y -= 1;
              this.m = 12;
            }
            this.loading = false;
          }
          console.log("this.itemList", this.itemList);
          // this.itemList = [...this.itemList,...arr]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goEdit1(val) {
      console.log(val[Object.keys(val)[0]]);
      // 当日的对象
      const currentObj = val[Object.keys(val)[0]];
      if (currentObj.height || currentObj.weight) {
        this.$router.push({
          path: "/physique/edit",
          query: {
            type: 1,
            date: currentObj.date,
            bmi: currentObj.bmi,
            height: currentObj.height,
            weight: currentObj.weight,
            hipline: currentObj.hipline,
            waistline: currentObj.waistline,
          },
        });
      } else {
        this.$router.push({
          path: "/physique/edit",
          query: {
            type: 1,
            date: currentObj.date,
            bmi: 0,
            height: 0,
            weight: 0,
            hipline: 0,
            waistline: 0,
          },
        });
      }
    },
    goEdit(index, bmi, height, weight, hipline, waistline) {
      console.log(index, bmi, height, weight, hipline, waistline);
      this.$router.push({
        path: "/physique/edit",
        query: {
          type: 1,
          date: index,
          bmi: bmi,
          height: height,
          weight: weight,
          hipline: hipline,
          waistline: waistline,
        },
      });
      // this.$router.push({name:'editphysique',params:{type:1,
      //     date:index,
      //     bmi:bmi,
      //     height:height,
      //     weight:weight,
      //     hipline:hipline,
      //     waistline:waistline
      // }})
    },
    //获取当前年月
    timer() {
      if (this.m < 10) {
        return this.y + "-" + "0" + this.m;
      } else {
        return this.y + "-" + this.m;
      }
    },
    //获取指定年月最大有多少天
    getMouthDay(y, m) {
      let days = new Date(y, m, 0).getDate();
      return days;
    },
    // echart
    changeChart() {
      // 表格数据
      this.option = {
        tooltip: {
          trigger: "axis",
        },
        // 边距
        grid: {
          x: 40,
          y: 40,
          x2: 10,
          y2: 40,
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#333",
              },
            },
            axisLabel: {
              // X坐标轴刻度标签的相关设置。
              textStyle: {
                color: "#333",
                fontSize: 12,
              },
              formatter: function (params) {
                let newParamsName = String(params); // 最终拼接成的字符串
                newParamsName = newParamsName.replace("-", "\n");
                //将最终的字符串返回
                return newParamsName;
              },
            },
            data: this.dataX,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: `（${this.danwei}）`,
            // y轴刻度线
            splitLine: {
              show: true,
            },
            // y轴文字颜色
            axisLabel: {
              textStyle: {
                color: "#333",
                fontSize: 12,
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            name: this.goChoseName,
            smooth: true,
            data: this.dataY,
          },
        ],
      };
    },
  },
};
</script>

<style scoped lang="scss">
.physiquePage {
  width: 100%;
  height: 100%;

  .physique {
    width: 375px;
    height: 156px;
    background: url("../assets/imgs/体格-pic@2x.png");
    background-size: 100% auto;

    .physique-img {
      padding-top: 25px;
      margin-left: 16px;
    }
  }
  .chart_box {
    box-sizing: border-box;
    padding: 10px;
    .chart_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .chart_top_r {
        background: #f7f7f7;
        padding: 5px;
        font-size: 12px;
        color: #506b9c;
        border: 0.5px solid #eeeeee;
        border-radius: 4px;
      }
    }
    .chart_bottom {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      .chose_btn,
      .btn {
        width: 19%;
        padding: 7px 0;
        border-radius: 4px;
        background: #f2f2f2;
        text-align: center;
      }
      .chose_btn {
        position: relative;
        background: #224a91;
        color: #fff;
      }
      .chose_btn::before {
        position: absolute;
        content: "";
        top: -7px;
        transform: translateX(8px);
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #224a91;
      }
    }
  }
  .info-box {
    margin-bottom: 100px;
    margin-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    .info-title {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      .info-title-txt {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .info-box-items {
      height: 158px;
      /*opacity: 0.2;*/
      border-left: 1px dashed #979797;

      .items-dian {
        opacity: 1;
        margin-left: -4px;
        width: 6px;
        height: 6px;
        background: #224a91;
        opacity: 1;
        border: 1px solid #ffffff;
        border-radius: 50%;
      }

      .item-w {
        width: 325px;
        margin-left: 18px;

        .item-date {
          margin-top: -5px;
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          /*line-height: 18px;*/
        }

        .item-box {
          margin-top: 10px;
          height: 90px;
          background: #f3f7fb;
          border-radius: 8px;
          padding: 16px 12px;

          .item-box-bottom {
            margin-top: 12px;
            display: flex;

            .font2 {
              margin-left: 80px;
            }

            .font {
              /*overflow: hidden;*/
              height: 18px;
              font-size: 13px;
              font-weight: 400;
              color: #333333;
              line-height: 18px;
            }
          }

          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }

  .info-btn {
    position: fixed;
    bottom: 44px;
    left: 24px;
    width: 327px;
    height: 44px;
    background: #224a91;
    border-radius: 4px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #fefffe;
    line-height: 44px;
  }

  .BMI-font {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 22px;
  }

  .BMI-icon {
    margin-left: 2px;
    font-size: 13px;
    font-weight: 400;
    text-align: right;
    color: #224a91;
    line-height: 20px;
  }
}
</style>
